import React, { useMemo } from 'react';
import {
  useMaterialReactTable,
  MRT_TableContainer,
} from 'material-react-table';
import { FaTrash } from 'react-icons/fa';

const ScorecardTable = ({ formik, data, setData }) => {

  const columns = useMemo(
    () => [
      {
        header: 'Title',
        accessorKey: 'title',
        // size: 200, // Let it be auto or flex
        muiTableHeadCellProps: {
            style: {
              background: "#FEC025",
              border: "1px solid #E9ECEF",
              textAlign: "center",
              fontSize: "14px",
              color: 'black',
              fontWeight: 'normal',
            },
        },
        Cell: ({ row }) => (
          <input
            type="text"
            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center', background: 'transparent' }}
            value={formik.values.scorecard_section[row.index]?.title || ''}
            onChange={(e) => formik.setFieldValue(`scorecard_section.${row.index}.title`, e.target.value)}
          />
        ),
      },
      {
        header: 'Goal',
        accessorKey: 'goal',
        // size: 200,
        muiTableHeadCellProps: {
            style: {
              background: "#FEC025",
              border: "1px solid #E9ECEF",
              textAlign: "center",
              fontSize: "14px",
              color: 'black',
              fontWeight: 'normal',
            },
        },
        Cell: ({ row }) => (
          <input
            type="text"
             style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center', background: 'transparent' }}
            value={formik.values.scorecard_section[row.index]?.goal || ''}
            onChange={(e) => formik.setFieldValue(`scorecard_section.${row.index}.goal`, e.target.value)}
          />
        ),
      },
      {
        header: 'Average',
        accessorKey: 'average',
        // size: 100,
        muiTableHeadCellProps: {
            style: {
              background: "#FEC025",
              border: "1px solid #E9ECEF",
              textAlign: "center",
              fontSize: "14px",
              color: 'black',
              fontWeight: 'normal',
            },
        },
        Cell: ({ row }) => (
          <input
            type="text"
             style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center', background: 'transparent' }}
            value={formik.values.scorecard_section[row.index]?.average || ''}
            onChange={(e) => formik.setFieldValue(`scorecard_section.${row.index}.average`, e.target.value)}
          />
        ),
      },
       {
        header: 'Total',
        accessorKey: 'total',
        // size: 100,
        muiTableHeadCellProps: {
            style: {
              background: "#FEC025",
              border: "1px solid #E9ECEF",
              textAlign: "center",
              fontSize: "14px",
              color: 'black',
              fontWeight: 'normal',
            },
        },
        Cell: ({ row }) => (
          <input
            type="text"
             style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center', background: 'transparent' }}
            value={formik.values.scorecard_section[row.index]?.total || ''}
             onChange={(e) => formik.setFieldValue(`scorecard_section.${row.index}.total`, e.target.value)}
          />
        ),
      },
     {
        header: 'Action',
        id: 'actions',
        size: 80,
        muiTableHeadCellProps: {
            style: {
              background: "#FEC025",
              border: "1px solid #E9ECEF",
              textAlign: "center",
              fontSize: "14px",
              color: 'black',
              fontWeight: 'normal',
            },
        },
        Cell: ({ row }) => (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px'}}>
           <FaTrash
              className='delete-buttonXX cursor-pointer'
              onClick={() => {
                const newData = [...data];
                newData.splice(row.index, 1);
                setData(newData);
              }}
            />
            </div>
        ),
      },
    ],
    [data, formik.values.scorecard_section]
  );

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: data,
    enableRowOrdering: true,
    enableSorting: false,
    enablePagination: false, 
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          const newData = [...data];
          newData.splice(
            hoveredRow.index,
            0,
            newData.splice(draggingRow.index, 1)[0]
          );
          setData(newData);
        }
      },
    }),
    muiTablePaperProps: {
        elevation: 0,
        style: {
            border: 'none',
            boxShadow: 'none'
        }
    },
    muiTableBodyRowProps: {
        sx: {
           
        }
    },
    muiTableBodyCellProps: {
        style: {
             border: "1px solid #E9ECEF",
             padding: 0
        }
    }
  });

  return <MRT_TableContainer table={table} />;
};

export default ScorecardTable;
